(function () {
  var SECTION_SELECTOR = '.ctr-footer';
  var POLICIES_SELECTOR = '.ctr-footer__policies';

  function initPolicies(section) {
    if (!section || section.dataset.ctrFooterReady === 'true') return;

    section.dataset.ctrFooterReady = 'true';

    section.querySelectorAll(POLICIES_SELECTOR).forEach(function (policies) {
      var details = policies.querySelector('details');
      var trigger = policies.querySelector('.ctr-footer__policies-trigger');
      var menu = policies.querySelector('.ctr-footer__policies-menu');
      if (!details || !trigger || !menu) return;

      var closeTimer = null;

      function openMenu() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        details.setAttribute('open', '');
        trigger.setAttribute('aria-expanded', 'true');
      }

      function scheduleClose() {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
          trigger.setAttribute('aria-expanded', 'false');
          closeTimer = null;
        }, 100);
      }

      trigger.addEventListener('mouseenter', openMenu);
      trigger.addEventListener('focus', openMenu);
      menu.addEventListener('mouseenter', openMenu);

      trigger.addEventListener('mouseleave', scheduleClose);
      menu.addEventListener('mouseleave', scheduleClose);

      policies.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!policies.contains(document.activeElement)) {
            details.removeAttribute('open');
            trigger.setAttribute('aria-expanded', 'false');
          }
        }, 0);
      });
    });
  }

  function findSection(root) {
    if (!root) return null;
    if (root.matches && root.matches(SECTION_SELECTOR)) return root;
    return root.querySelector ? root.querySelector(SECTION_SELECTOR) : null;
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initPolicies);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = findSection(event.target);
    if (!section) return;
    delete section.dataset.ctrFooterReady;
    initPolicies(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = findSection(event.target);
    if (!section) return;
    delete section.dataset.ctrFooterReady;
  });
})();
